import React, { Fragment } from "react";

import TimesheetsContainer from "../../containers/Timesheets";
import TimesheetsTable from "../TimesheetsTable";
import * as style from "./styles.module.scss";
import history from "../../history";

/**
 * To use, import `components/Timesheets.jsx` into the page, or simply make that
 * the rendered route.
 *
 * The `containers/Timesheets.jsx` component interfaces with redux/redux-saga
 *
 * If we wish to preload the timesheets, it will be a simple case of putting
 * something like `shouldFetchData={true}` on `containers/Timesheets.jsx` then
 * only making the api call when that prop is true. Then we simply need to load
 * the component globally.
 */
const Timesheets = () => {
  return (
    <div>
      <TimesheetsContainer>
        {({ timesheets }) => {
          return (
            <Fragment style={{ maxWidth: "700px" }}>
              <div
                className="container"
                style={{ paddingTop: "20px", paddingBottom: "20px" }}
              >
                <h2 id="timesheetsHeader" className={style.timesheets_header}>
                  Your Timesheets
                </h2>
                <div className={style.timesheets_helpText}>
                  For any timesheet queries or issues, please contact our
                  Customer Success team, Monday - Friday between 9am - 5pm on
                  01233 515169 or via email at{" "}
                  <a href="mailto:customer.success@hrgo.co.uk">
                    customer.success@hrgo.co.uk
                  </a>
                </div>
                <TimesheetsTable timesheets={timesheets} />
              </div>
            </Fragment>
          );
        }}
      </TimesheetsContainer>
      <div
        className="container"
        style={{
          display: "flex",
          padding: "30px 0",
          justifyContent: "space-between",
        }}
      >
        <button
          onClick={() => history.push("/profile")}
          className="btn"
          style={{ backgroundColor: "lightgray" }}
        >
          Back to My Account
        </button>
      </div>
    </div>
  );
};

export default Timesheets;
